// Hebrew "missing fields" alert message from a list of field names.
export const missingMsg = missing =>
    missing.length == 1 ? 'יש למלא את ' + missing[0] : 'חסרים השדות הבאים: ' + missing.join(', ')

export const toLiteralMonth = month => {
    let list = {
        1: 'ינואר',
        2: 'פברואר',
        3: 'מרץ',
        4: 'אפריל',
        5: 'מאי',
        6: 'יוני',
        7: 'יולי',
        8: 'אוגוסט',
        9: 'ספטמבר',
        10: 'אוקטובר',
        11: 'נובמבר',
        12: 'דצמבר'
    }
    return list[month] || ''
}

// export const dateFormat = (str) => {
//     let [date, time] = str.split(' ')
//         date = date.replace(/-/g, '/').reverse()
//         // time = time.substring(0, time.lastIndexOf(':'))
//     return date
// }

export const dateFormat = str => {
    let date = new Date(str)
    let year = date.getFullYear()
    let month = date.getMonth() + 1

    return `${toLiteralMonth(month)} ${year}`
}
